var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',[_c('th',[_vm._v(" "+_vm._s(_vm.displayName)+" ")]),_c('td',[_c('div',{staticClass:"editor-container"},[_c('EumEditor',{attrs:{"mode":"editor","v-model":_vm.textModel,"tinyopts":_vm.tinyopts,"dext5opts":_vm.dext5opts}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }